'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_SimpleTextSearch(text, pageIndex, pageSize, sort) {
  this.zl = null;
  this.zj = 0;
  this.zk = 0;
  this.LD = null;
  this.zl = text;
  this.zj = pageIndex;
  this.zk = pageSize;
  this.LD = sort;
}
export { $c_Lmealorama_SimpleTextSearch as $c_Lmealorama_SimpleTextSearch };
$p = $c_Lmealorama_SimpleTextSearch.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_SimpleTextSearch;
/** @constructor */
function $h_Lmealorama_SimpleTextSearch() {
}
export { $h_Lmealorama_SimpleTextSearch as $h_Lmealorama_SimpleTextSearch };
$h_Lmealorama_SimpleTextSearch.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  var acc = (-889275714);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, 1670356135);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.zl));
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.zj);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, this.zk);
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().u(acc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().B(this.LD));
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().ax(acc, 4);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lmealorama_SimpleTextSearch)) {
    if ((((this.zj === x$0.zj) && (this.zk === x$0.zk)) && (this.zl === x$0.zl))) {
      var x = this.LD;
      var x$2 = x$0.LD;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.m = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().J(this);
});
$p.q = (function() {
  return 4;
});
$p.r = (function() {
  return "SimpleTextSearch";
});
$p.g = (function(n) {
  switch (n) {
    case 0: {
      return this.zl;
      break;
    }
    case 1: {
      return this.zj;
      break;
    }
    case 2: {
      return this.zk;
      break;
    }
    case 3: {
      return this.LD;
      break;
    }
    default: {
      throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__I__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), n);
    }
  }
});
function $isArrayOf_Lmealorama_SimpleTextSearch(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jV)));
}
export { $isArrayOf_Lmealorama_SimpleTextSearch as $isArrayOf_Lmealorama_SimpleTextSearch };
var $d_Lmealorama_SimpleTextSearch = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_SimpleTextSearch, "mealorama.SimpleTextSearch", ({
  jV: 1,
  bB: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lmealorama_SimpleTextSearch as $d_Lmealorama_SimpleTextSearch };
//# sourceMappingURL=mealorama.-Simple-Text-Search.js.map
